module.exports = ".datatable-footer {\n  border: none !important;\n  padding: 0px !important;\n  height: auto !important; }\n\n.container-fluid {\n  padding-right: 15px;\n  padding-left: 15px; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/custom_style.scss
// module id = 128
// module chunks = 9